export default "__VITE_ASSET__CiKoYHM___"